import { ReactElement, useCallback } from 'react'

import { useTrackBalanceEvent } from '@features/balanceLedger'

import type { PeriodMode } from '../../../../../../enums/periodMode'
import { useDownloadCreditorBalanceSummaryExport } from '../../../../hooks/useDownloadCreditorBalanceSummaryExport'
import { BALANCE_EXPORT_FORMATS, ExportMenu } from '../../../ExportMenu'

interface SuppliersBalanceExportMenuProps {
  accountCount?: number
  periodType?: PeriodMode
}

export const SuppliersBalanceExportMenu = ({
  accountCount,
  periodType,
}: SuppliersBalanceExportMenuProps): ReactElement => {
  const trackBalanceEvent = useTrackBalanceEvent()
  const { downloadExport, isExporting } = useDownloadCreditorBalanceSummaryExport({ accountCount })

  const trackExportClicked = useCallback(() => {
    /* eslint-disable @typescript-eslint/naming-convention */
    trackBalanceEvent('Export Clicked', {
      account_count: accountCount,
      export_options_available: BALANCE_EXPORT_FORMATS,
      period_type: periodType,
    })
    /* eslint-enable @typescript-eslint/naming-convention */
  }, [accountCount, periodType, trackBalanceEvent])

  return <ExportMenu isExporting={isExporting} onOpen={trackExportClicked} onSelectFormat={downloadExport} />
}
